import { render, staticRenderFns } from "./StickyFooter.vue?vue&type=template&id=afcc6330&scoped=true"
var script = {}
import style0 from "./StickyFooter.vue?vue&type=style&index=0&id=afcc6330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcc6330",
  null
  
)

export default component.exports